import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Password } from "primereact/password";
import "./UserDialogs.css";

const AddUserDialog = ({
  addUserDialogVisible,
  setAddUserDialogVisible,
  newUser,
  setNewUser,
  saveNewUser,
  toast,
}) => {
  return (
    <Dialog
      header="Add New User"
      visible={addUserDialogVisible}
      style={{ width: window.innerWidth > 768 ? "50vw" : "95vw" }}
      modal
      onHide={() => setAddUserDialogVisible(false)}
      className="user-dialog"
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flexDirection: window.innerWidth > 768 ? "row" : "column",
            gap: window.innerWidth > 768 ? "0.5rem" : "0.75rem",
          }}
        >
          <Button
            label="Cancel"
            icon="pi pi-times"
            style={{
              color: "#fff",
              backgroundColor: "#D97A07",
              border: "none",
            }}
            onClick={() => setAddUserDialogVisible(false)}
            className="p-button-text"
          />
          <Button
            label="Save"
            icon="pi pi-check"
            style={{
              color: "#fff",
              backgroundColor: "#0D2E4D",
              border: "none",
            }}
            onClick={saveNewUser}
          />
        </div>
      }
    >
      <div className="p-field">
        <label htmlFor="email">Email</label>
        <InputText
          id="email"
          value={newUser.email}
          onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
        />
      </div>
      <div className="p-field">
        <label htmlFor="username">Username</label>
        <InputText
          id="username"
          value={newUser.username}
          onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
        />
      </div>
      <div className="p-field p-fluid">
        <label htmlFor="password">Password</label>
        <Password
          toggleMask
          id="password"
          value={newUser.password}
          onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          feedback={false}
        />
      </div>
      <div className="p-field p-fluid">
        <label htmlFor="confirmPassword">Confirm Password</label>
        <Password
          toggleMask
          id="confirmPassword"
          value={newUser.confirmPassword}
          onChange={(e) =>
            setNewUser({ ...newUser, confirmPassword: e.target.value })
          }
          feedback={false}
        />
      </div>
      <div className="p-field">
        <label htmlFor="roles">Role</label>
        <Dropdown
          id="roles"
          value={newUser.roles?.[0] || ""}
          options={[
            { label: "Admin", value: "ROLE_ADMIN" },
            { label: "Super User", value: "ROLE_SUPERUSER" },
            { label: "User", value: "ROLE_USER" },
          ]}
          optionLabel="label"
          placeholder="Select a role"
          onChange={(e) => setNewUser({ ...newUser, roles: [e.value] })}
        />
      </div>
    </Dialog>
  );
};

export default AddUserDialog;
